module.exports = __webpack_public_path__ + "static/media/seagulls.a8600946.mp3";